// extracted by mini-css-extract-plugin
export default {"dogWithBone":"dtF4ys","container":"rNZ4fe"};